export default __webpack_public_path__ + "static/media/avatar1.9e10a7ce.svg";